"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BevelSettingsProps = exports.BevelSettings = void 0;
/*
 * Copyright (c) 2023 Discover Financial Services
 * Licensed under MIT License. See License.txt in the project root for license information
 */
const atom_1 = require("./atom");
const props_1 = require("../common/props");
/**
 * The BevelSettings atom.
 * @category Atoms
 */
class BevelSettings extends atom_1.Atom {
    constructor(atoms) {
        super("Bevel Settings", false, atoms);
        this.addDependency(atoms.colorThemes);
        this.standard = new BevelSettingsProps(true, this);
        this.inverse = new BevelSettingsProps(false, this);
    }
    deserialize(obj) {
        if (!obj)
            return;
        super.deserialize(obj);
        this.standard.deserialize(obj.standard);
        this.inverse.deserialize(obj.inverse);
    }
    serialize() {
        const obj = {};
        obj.standard = this.standard.serialize();
        obj.inverse = this.inverse.serialize();
        return obj;
    }
}
exports.BevelSettings = BevelSettings;
/**
 * The bevel settings.
 * @category Atoms
 */
class BevelSettingsProps {
    constructor(standard, bs) {
        this.standard = standard;
        const p = standard ? "Standard " : "Inverse";
        this.horizontalShadowLength = new props_1.PropertyNumberRange(`${p} Horizontal Shadow Length`, false, bs, 0, 10, 6);
        this.verticalShadowLength = new props_1.PropertyNumberRange(`${p} Vertical Shadow Length`, false, bs, 0, 10, 6);
        this.blurRadius = new props_1.PropertyNumberRange(`${p} Blur Radius`, false, bs, 0, 10, 6);
        this.spreadRadius = new props_1.PropertyNumberRange(`${p} Spread Radius`, false, bs, 0, 10, 1);
        this.lightGlowOpacity = new props_1.PropertyNumberRange(`${p} Light Glow Opacity`, false, bs, 0, 100, 30);
        this.darkShadowOpacity = new props_1.PropertyNumberRange(`${p} Dark Shadow Opacity`, false, bs, 0, 100, 50);
        this.percentageChange = new props_1.PropertyPercentage(`${p} Percentage Change`, false, bs, 20);
    }
    deserialize(obj) {
        if (!obj)
            return;
        this.horizontalShadowLength.deserialize(obj.horizontalShadowLength);
        this.verticalShadowLength.deserialize(obj.verticalShadowLength);
        this.blurRadius.deserialize(obj.blurRadius);
        this.spreadRadius.deserialize(obj.spreadRadius);
        this.lightGlowOpacity.deserialize(obj.lightGlowOpacity);
        this.darkShadowOpacity.deserialize(obj.darkShadowOpacity);
        this.percentageChange.deserialize(obj.percentageChange);
    }
    serialize() {
        const obj = {};
        obj.horizontalShadowLength = this.horizontalShadowLength.serialize();
        obj.verticalShadowLength = this.verticalShadowLength.serialize();
        obj.blurRadius = this.blurRadius.serialize();
        obj.spreadRadius = this.spreadRadius.serialize();
        obj.lightGlowOpacity = this.lightGlowOpacity.serialize();
        obj.darkShadowOpacity = this.darkShadowOpacity.serialize();
        obj.percentageChange = this.percentageChange.serialize();
        return obj;
    }
}
exports.BevelSettingsProps = BevelSettingsProps;
